import type { FC } from "react"

import { ButtonLg } from "./buttons/ButtonLg"
import { ButtonMd } from "./buttons/ButtonMd"
import { ButtonS_V2 } from "./buttons/ButtonS_V2"
import { ButtonSm } from "./buttons/ButtonSm"
import { ButtonXs } from "./buttons/ButtonXs"
import { ButtonXXL } from "./buttons/ButtonXXL"

export enum UbiqButtonType {
  DARK,
  LIGHT,
}

export enum UbiqButtonSize {
  EXTRA_SMALL,
  SMALL,
  SMALL_V2,
  MEDIUM,
  LARGE,
  EXTRA_LARGE,
}

const getButtonBg = (size: UbiqButtonSize, type: UbiqButtonType) => {
  switch (size) {
    case UbiqButtonSize.EXTRA_SMALL:
      return <ButtonXs type={type} />
    case UbiqButtonSize.SMALL_V2:
      return <ButtonS_V2 type={type} />
    case UbiqButtonSize.SMALL:
      return <ButtonSm type={type} />
    case UbiqButtonSize.MEDIUM:
      return <ButtonMd type={type} />
    case UbiqButtonSize.LARGE:
      return <ButtonLg type={type} />
    case UbiqButtonSize.EXTRA_LARGE:
      return <ButtonXXL type={type} />
    default:
      return <ButtonSm type={type} />
  }
}

const UbiqButton: FC<{
  title: string
  styles?: string
  buttonType?: UbiqButtonType
  disabled?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  type?: "button" | "submit" | "reset" | undefined
  size?: UbiqButtonSize
  error?: string
}> = ({
  title,
  styles = "",
  buttonType = UbiqButtonType.DARK,
  disabled = false,
  onClick,
  type = "submit",
  size = UbiqButtonSize.SMALL,
  error,
}) => {
  const bgComponent = getButtonBg(size, buttonType)

  return (
    <div className="flex flex-col items-center">
      <button
        className={`h-12 w-full bg-no-repeat text-primary-h5 sm:w-fit text-[13px] bg-cover relative group flex justify-center items-center
        ${disabled ? "opacity-50 pointer-events-none" : ""}
        ${styles} 
        ${buttonType === UbiqButtonType.DARK ? "text-white" : "text-[#333035] "}`}
        disabled={disabled}
        onClick={(e) => onClick?.(e)}
        type={type}
      >
        <span
          className={`w-full absolute  left-[calc(50%-2px)] z-[3]  transform -translate-x-1/2 -translate-y-1/2 group-hover:left-1/2 group-active:left-[calc(50%+1px)] ${
            size === UbiqButtonSize.EXTRA_SMALL
              ? "group-hover:top-[22.4px] group-active:top-[50%] top-[calc(50%-3px)]"
              : "group-hover:top-1/2 group-active:top-[calc(50%+1px)] top-[calc(50%-2px)]"
          }`}
        >
          {title}
        </span>
        <div className="relative z-[2]">{bgComponent}</div>
      </button>
      {!!error && <p className="text-[11px] text-red-500 mt-2">{error}</p>}
    </div>
  )
}

export default UbiqButton
